'use client';

import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  CheckboxGroup,
  Flex,
  Text,
} from '@chakra-ui/react';
import { FC, useCallback } from 'react';
import FilterItemsGroupName from '@/components/UI/Filter/FilterItemsGroupName';
import { IAppCategory } from '@/types/api/app/category';

interface CategoriesFilterProps {
  categories?: IAppCategory[];
  categoryOptions?: IAppCategory[];
  onCategoriesChange?: (categories: IAppCategory[]) => void;
}
const CategoriesFilter: FC<CategoriesFilterProps> = ({
  categories = [],
  onCategoriesChange,
  categoryOptions = [],
}) => {
  const handleChange = useCallback(
    (selectedIds: string[]) => {
      onCategoriesChange?.(
        categoryOptions.filter(
          ({ id }) =>
            !!selectedIds.find((selectedId) => selectedId === id.toString())
        )
      );
    },
    [categoryOptions, onCategoriesChange]
  );

  return (
    <Accordion
      defaultIndex={[0]}
      allowMultiple
      onClick={(e) => e.stopPropagation()}
    >
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <FilterItemsGroupName isExpanded={isExpanded}>
              Category
            </FilterItemsGroupName>
            <AccordionPanel mt="1rem" px="0" pt="0">
              <CheckboxGroup
                value={categories.map(({ id }) => id.toString())}
                onChange={handleChange}
              >
                <Flex flexDir="column" gap="0.75rem" userSelect="none">
                  {categoryOptions.map(({ id, title }) => (
                    <Checkbox value={id.toString()} key={id}>
                      <Text
                        color="primary.300"
                        cursor="pointer"
                        userSelect="none"
                        fontSize="0.9375rem"
                        fontWeight="300"
                        lineHeight="1.25rem"
                      >
                        {title}
                      </Text>
                    </Checkbox>
                  ))}
                </Flex>
              </CheckboxGroup>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default CategoriesFilter;
